import type { RouteRecordRaw } from 'vue-router';

import CouponRedemption from './components/CouponRedemption.vue';
import ReferralOffer from './components/ReferralOffer.vue';
import WebinarCertificate from './components/WebinarCertificate.vue';

export const publicFlowRoutes: RouteRecordRaw[] = [
    {
        path: '/coupon/:coupon',
        name: 'coupon.redemption',
        component: CouponRedemption,
        meta: { public: true, title: 'Redeem Coupon' },
    },
    {
        path: '/webinars/:webinar',
        name: 'webinar.certificate',
        component: WebinarCertificate,
        meta: { public: true, title: 'Webinar Certificate' },
    },
    {
        path: '/refer/:referralCode',
        name: 'referral.offer',
        component: ReferralOffer,
        meta: { public: true, title: 'Referral Offer' },
    },
];
